import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailWithTldValidator } from 'src/app/validators/email-tld.validator';
import { cpfValidator, cpfCnpjValidator } from 'src/app/validators/cpf-cnpj.validator';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { IPatient } from 'src/app/models/patient.model';
import { ICountriesDDI } from 'src/app/models/countries-ddi.model';
import { countriesDdi } from 'src/app/models/countries_ddi';
import { IError } from 'src/app/models/error.model';
import { IAnamneseDetail } from 'src/app/models/anamnese.model';
import { IContractDetail } from 'src/app/models/contract-detail.model';
import { AnamneseSectionDto } from 'src/app/models/anamnese-section.model';
import { IAnamneseQuestion, AnamneseQuestionOptionDto } from 'src/app/models/anamnese-form-question.model';
import { IAnamneseAnswer } from 'src/app/models/anamnese-form-answer.model';
import { PatientsService } from 'src/app/services/patients.service';
import { AnamneseService } from 'src/app/services/anamnese.service';
import { DocumentsService } from 'src/app/services/documents.service';
import { TreatmentPlanService } from 'src/app/services/treatment-plan.service';
import { ModulesService } from 'src/app/services/modules.service';
import { AuthService } from 'src/app/services/auth.service';
import { hasTreatmentPlanAccess } from 'src/app/utils/user-permissions.utils';
import { ITreatmentPlanDetailed } from 'src/app/models/treatment-plan.model';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';
import { openCloseAnamneseChoosePopupModal, setAnamneseChoosePopupType } from 'src/app/reducers/anamnese-choose-popup.reducer';
import { IAnamneseChoosePopupModal } from 'src/app/models/anamnese-choose-popup-modal.model';
import { faSort, faSortUp, faSortDown, faEye, faTrash, faExternalLinkAlt, faWarning, faTimes, faChevronLeft, faPrint, faFileAlt, faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faPaperPlane, faInfoCircle, faCopy, faLock, faCheck } from '@fortawesome/free-solid-svg-icons';
import { DropdownOption } from '../../components/custom-dropdown/custom-dropdown.component';

@Component({
  selector: 'app-patient-edit-v2',
  templateUrl: './patient-edit.component.html',
  styleUrls: ['./patient-edit.component.sass']
})
export class PatientEditV2Component implements OnInit {
  loading = false;
  patientForm!: FormGroup;
  patientId: string | null = '';
  patientData: IPatient | null = null;

  countriesDdi = countriesDdi;
  filteredPhoneCountries = countriesDdi;
  filteredCountries = countriesDdi;
  filteredGuardianPhoneCountries = countriesDdi;
  isDropdownPhoneOpen = false;
  isDropdownCountryOpen = false;
  isDropdownGuardianPhoneOpen = false;
  showModelPatientCheckbox = false;

  // Opções para dropdowns
  maritalStatusOptions: DropdownOption[] = [
    { value: 'Solteiro(a)', label: 'Solteiro(a)' },
    { value: 'Casado(a)', label: 'Casado(a)' },
    { value: 'Separado(a)', label: 'Separado(a)' },
    { value: 'Divorciado(a)', label: 'Divorciado(a)' },
    { value: 'Viúvo(a)', label: 'Viúvo(a)' }
  ];

  // Icons
  faSort = faSort;
  faSortUp = faSortUp;
  faSortDown = faSortDown;
  faEye = faEye;
  faTrash = faTrash;
  faExternalLinkAlt = faExternalLinkAlt;
  faWarning = faWarning;
  faTimes = faTimes;
  faChevronLeft = faChevronLeft;
  faPrint = faPrint;
  faFileAlt = faFileAlt;
  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleDoubleRight = faAngleDoubleRight;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faPaperPlane = faPaperPlane;
  faInfoCircle = faInfoCircle;
  faCopy = faCopy;
  faLock = faLock;
  faDelete = faTrash;
  faCheck = faCheck;



  // Tooltip state for lock tooltip
  lockTooltipVisibleFor: string | null = null; // answer_group_id
  lockTooltipLeft = 0;
  lockTooltipTop = 0;

  showLockTooltip(event: MouseEvent, answerGroupId: string): void {
    if (!answerGroupId) return;
    // Only show tooltip when deletion is NOT allowed
    const doc = this.documents.find(d => d.answer_group_id === answerGroupId);
    if (doc && this.canDeleteDocument(doc)) return;

    // Position tooltip relative to the cursor: show to the left of the cursor
    const clientX = event.clientX || 0;
    const clientY = event.clientY || 0;
    // left coordinate will be shifted via translateX(-100%) in the template so
    // we set the anchor point near the cursor X
    this.lockTooltipLeft = Math.round(clientX - 8);
    // position tooltip slightly above the cursor
    this.lockTooltipTop = Math.round(clientY - 16);
    this.lockTooltipVisibleFor = answerGroupId;
  }

  hideLockTooltip(): void {
    this.lockTooltipVisibleFor = null;
  }

  // Reenvio de documentos
  resendLoading: string | null = null;

  // Menu de seleção - 3 tabs
  activeSection = 'dadosPessoais';

  // Ficha de Anamnese - Visualização detalhada
  selectedAnamnese: IAnamneseDetail | null = null;
  anamneseSections: AnamneseSectionDto[] = [];
  loadingAnamneseDetail = false;

  // Modal Enviar Anamnese
  showAnamneseModal = false;
  anamneseModalLoading = false;
  hasPreviousAnamnese = false;
  hasUnansweredAnamnese = false;
  ongoingAnamneseId = '';
  hasAnsweredAnamnese = false;
  latestAnsweredAnamneseId: string | null = null;

  // Anamnese list
  anamneses: IAnamneseDetail[] = [];
  anamneseCurrentPage = 0;
  anamneseTotalPages = 0;
  anamnesePageSize = 10;
  anamneseSortBy = 'DESC';
  anamneseOrderBy = 'createdAt';

  // Documents list
  documents: IContractDetail[] = [];
  documentsCurrentPage = 0;
  documentsTotalPages = 0;
  documentsPageSize = 10;

  // Treatment Plans list
  treatmentPlans: ITreatmentPlanDetailed[] = [];
  treatmentPlansCurrentPage = 0;
  treatmentPlansTotalPages = 0;
  treatmentPlansPageSize = 10;
  treatmentPlansStatusFilter: 'ACTIVE' | 'CLOSED' = 'ACTIVE';
  loadingTreatmentPlans = false;
  hasTreatmentPlanAccess = false;

  // Módulo dinâmico
  viewModules$: Observable<{ moduleName: string; moduleNamePascalCase: string; moduleNameInSingular: string; }>;
  anamneseChoosePopupModal: Observable<IAnamneseChoosePopupModal>;
  hasToShowAnamnese: boolean;

  // Cálculo de idade para exibir dados do responsável
  patientAge: number | null = null;
  isMinor = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private patientsService: PatientsService,
    private anamneseService: AnamneseService,
  private documentsService: DocumentsService,
  private treatmentPlanService: TreatmentPlanService,
  private authService: AuthService,
    private store: Store<{ warningPopup: IError; anamneseChoosePopupModal: IAnamneseChoosePopupModal }>,
    private cdr: ChangeDetectorRef,
    public modulesService: ModulesService
  ) {
    this.viewModules$ = combineLatest({
      moduleName: this.modulesService.moduleName$,
      moduleNamePascalCase: this.modulesService.moduleNamePascalCase$,
      moduleNameInSingular: this.modulesService.moduleNameInSingular$
    });
    this.hasToShowAnamnese = ['VIRTUAL', 'BOTH'].includes(this.authService.getAnamneseAuthType());
    this.anamneseChoosePopupModal = this.store.select('anamneseChoosePopupModal');
  }

  ngOnInit(): void {
    this.initForm();
    this.evaluateModelPatientVisibility();
    this.loading = true;

    // Verificar se o usuário tem acesso aos planos de tratamento
    const userId = this.authService.getUserId();
    const clinicCnpj = this.authService.getClinicCnpj();
    this.hasTreatmentPlanAccess = hasTreatmentPlanAccess(userId, clinicCnpj) && this.modulesService.moduleName === 'PACIENTES';

    this.route.paramMap.subscribe(params => {
      this.patientId = params.get('patientId');
      if (this.patientId) {
        this.loadPatient();
      }
    });
  }

  // Avalia se deve mostrar o checkbox baseado no módulo e feature da clínica
  private evaluateModelPatientVisibility(): void {
    const isPacientesModule = this.modulesService.moduleName === 'PACIENTES';
    const hasPermission = this.authService.getPatientModelPermission();
    this.showModelPatientCheckbox = isPacientesModule && hasPermission;
  }

  private getModuleRouteBase(): string[] {
    const moduleName = (this.modulesService.moduleName || '').toString().toUpperCase();
    if (moduleName === 'PACIENTES') {
      return ['main', 'v2', 'patients'];
    }
    return ['main', 'v2', 'modules', moduleName.toLowerCase()];
  }

  private gotoModuleList(): void {
    const base = this.getModuleRouteBase();
    this.router.navigate(base);
  }

  initForm(): void {
    this.patientForm = this.fb.group({
      name: ['', [Validators.required]],
     email: ['', [emailWithTldValidator()]],
      phone: [''],
      phoneCountryCode: ['Brasil'],
      birthDate: [''],
      profession: [''],
      maritalStatus: [''],
      isForeigner: [false],
      isModelPatient: [false],
      instagramAccount: [''],
      rg: [''],
      cpf: ['', [this.modulesService.moduleName === 'ALUNOS' ? cpfCnpjValidator() : cpfValidator()]],
      zipCode: [''],
      street: [''],
      number: [''],
      complement: [''],
      neighborhood: [''],
      city: [''],
      state: [''],
      country: ['Brasil'],
      // Campos do responsável legal
      guardianName: [''],
      guardianCpf: ['', [cpfValidator()]],
      guardianPhone: [''],
      guardianPhoneCountryCode: ['Brasil']
    });
  }

  loadPatient(): void {
    if (!this.patientId) return;

    this.patientsService.getPatientById(this.patientId).subscribe({
      next: (response) => {
        this.patientData = response;
        this.patientForm.patchValue({
          name: response.full_name || '',
          email: response.email || '',
          phone: response.phone?.replace(/\D/g, '') || '',
          phoneCountryCode: response.phone_country_code || 'Brasil',
          birthDate: this.formatDateToDisplay(response.birth_date),
          profession: response.profession || '',
          maritalStatus: response.marital_status || '',
          isForeigner: response.is_foreigner || false,
          isModelPatient: response.is_model_patient || false,
          instagramAccount: response.instagram_account || '',
          rg: response.rg || '',
          cpf: response.cpf || '',
          zipCode: response.address?.zip_code || '',
          street: response.address?.street || '',
          number: response.address?.number || '',
          complement: response.address?.complement || '',
          neighborhood: response.address?.neighborhood || '',
          city: response.address?.city || '',
          state: response.address?.state || '',
          country: response.address?.country || 'Brasil',
          // Dados do responsável legal
          guardianName: response.guardian_name || '',
          guardianCpf: response.guardian_cpf || '',
          guardianPhone: response.guardian_phone || '',
          guardianPhoneCountryCode: response.guardian_phone_country_code || 'Brasil'
        });
        // Calcula idade e verifica se é menor
        this.patientAge = this.calculateAge(response.birth_date);
        this.isMinor = this.patientAge !== null && this.patientAge < 18;
        this.loading = false;
        this.loadAnamneses();
        this.loadDocuments();
        if (this.hasTreatmentPlanAccess) {
          this.loadTreatmentPlans();
        }
      },
      error: (error) => {
        console.error('Erro ao buscar paciente:', error);
        this.loading = false;
        this.gotoModuleList();
      }
    });
  }

  /**
   * Calcula a idade do paciente baseado na data de nascimento
   */
  private calculateAge(birthDateString: string | null | undefined): number | null {
    if (!birthDateString) {
      return null;
    }

    let birthDate: Date;
    // Tentar normalizar a data, comum vir como AAAA-MM-DD ou DD/MM/AAAA
    if (birthDateString.includes('-')) { // Formato AAAA-MM-DD
      const parts = birthDateString.split('-');
      birthDate = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    } else if (birthDateString.includes('/')) { // Formato DD/MM/AAAA
      const parts = birthDateString.split('/');
      birthDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
    } else {
      return null;
    }

    if (isNaN(birthDate.getTime())) {
      return null;
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age < 0 ? 0 : age;
  }

  formatDateToDisplay(dateString: string | undefined): string {
    if (!dateString) return '';
    
    // Se já está no formato DD/MM/YYYY, retorna diretamente
    if (dateString.includes('/') && dateString.split('/').length === 3) {
      return dateString;
    }
    
    // Tenta fazer parse de formato ISO (YYYY-MM-DD)
    let date: Date;
    if (dateString.includes('-')) {
      const parts = dateString.split('-');
      date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    } else {
      date = new Date(dateString);
    }
    
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // ========== ANAMNESE ==========
  loadAnamneses(): void {
    if (!this.patientId) return;

    this.anamneseService.listAnamneses(
      this.anamneseCurrentPage,
      this.anamnesePageSize,
      this.anamneseSortBy,
      this.anamneseOrderBy,
      this.patientId || '',
      this.modulesService.moduleId || ''
    ).subscribe({
      next: (response) => {
        this.anamneses = response.data || [];
        this.anamneseTotalPages = response.page_info?.total_pages || 0;
        this.updateAnamneseStatus();
      },
      error: (error: any) => {
        console.error('Erro ao carregar anamneses:', error);
      }
    });
  }

  updateAnamneseStatus(): void {
    const answeredAnamneses = this.anamneses.filter(a => a.is_answered && a.created_at);
    if (answeredAnamneses.length > 0) {
      const latest = answeredAnamneses.sort((a, b) => 
        new Date(b.created_at as string).getTime() - new Date(a.created_at as string).getTime()
      )[0];
      this.hasAnsweredAnamnese = true;
      this.latestAnsweredAnamneseId = latest.id || null;
    } else {
      this.hasAnsweredAnamnese = false;
      this.latestAnsweredAnamneseId = null;
    }
  }

  changeAnamneseOrdernation(field: string): void {
    if (this.anamneseOrderBy === field) {
      this.anamneseSortBy = this.anamneseSortBy === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.anamneseOrderBy = field;
      this.anamneseSortBy = 'DESC';
    }
    this.loadAnamneses();
  }

  // ========== FICHA DE ANAMNESE ==========
  viewAnamnese(anamnese: IAnamneseDetail): void {
    if (anamnese.is_answered) {
      // Anamnese respondida: vai para a tela de visualização das respostas
      this.router.navigate(['main', 'v2', 'patients', 'anamnese', anamnese.id]);
    } else {
      // Anamnese não respondida: vai para a tela com QR code e link
      this.router.navigate(['main', 'v2', 'patients', 'anamnese', anamnese.id, 'view']);
    }
  }

  // Modal-based delete for anamnese (v2) - replaces native confirm()
  deleteAnamnese(anamneseId: string): void {
    if (!anamneseId) return;
    this.showAnamneseDeleteModal(anamneseId);
  }

  // Modal state for confirm delete anamnese
  public showConfirmDeleteAnamnesePopup = false;
  public pendingDeleteAnamneseId: string | null = null;
  public confirmDeleteAnamneseLoading = false;

  showAnamneseDeleteModal(anamneseId?: string): void {
    if (anamneseId) this.pendingDeleteAnamneseId = anamneseId;
    this.showConfirmDeleteAnamnesePopup = true;
    try { this.cdr.detectChanges(); } catch (e) { /* noop */ }
    setTimeout(() => {
      const btn = document.getElementById('confirm-delete-anamnese-cancel-btn') as HTMLButtonElement | null;
      if (btn) btn.focus();
    }, 0);
  }

  closeAnamneseDeleteModal(): void {
    this.showConfirmDeleteAnamnesePopup = false;
    this.pendingDeleteAnamneseId = null;
  }

  confirmDeleteAnamnese(): void {
    const id = this.pendingDeleteAnamneseId;
    if (!id) return;
    this.confirmDeleteAnamneseLoading = true;
    this.anamneseService.deleteAnamnese(id).subscribe({
      next: () => {
        this.closeAnamneseDeleteModal();
        this.loadAnamneses();
      },
      error: (error: any) => {
        console.error('Erro ao excluir anamnese:', error);
        // show a warning modal with the error
        const errMsg = error?.message || 'Erro ao excluir anamnese. Tente novamente.';
        const errStatus = error?.status || 500;
        this.store.dispatch(setWarningText(errMsg, errStatus));
        this.closeAnamneseDeleteModal();
      }
    }).add(() => {
      this.confirmDeleteAnamneseLoading = false;
    });
  }

  anamnesePrevious(): void {
    if (this.anamneseCurrentPage > 0) {
      this.anamneseCurrentPage--;
      this.loadAnamneses();
    }
  }

  anamneseNext(): void {
    if (this.anamneseCurrentPage < this.anamneseTotalPages - 1) {
      this.anamneseCurrentPage++;
      this.loadAnamneses();
    }
  }

  anamneseNavigateTo(page: number): void {
    this.anamneseCurrentPage = page - 1;
    this.loadAnamneses();
  }

  changeAnamnesePageSize(event: Event): void {
    this.anamnesePageSize = parseInt((event.target as HTMLSelectElement).value);
    this.anamneseCurrentPage = 0;
    this.loadAnamneses();
  }

  // ========== DOCUMENTS ==========
  loadDocuments(): void {
    if (!this.patientId) return;

    this.documentsService.getDocuments(
      this.patientId,
      this.documentsCurrentPage,
      this.documentsPageSize
    ).then((response) => {
      this.documents = response.data || [];
     
      this.documentsTotalPages = response.total_pages || 0;
    }).catch((error: any) => {
      console.error('Erro ao carregar documentos:', error);
    });
  }

  getContractStatus(status: string): { message: string; color: string } {
    const singular = this.modulesService.moduleNameInSingular || 'Pac.';
    const shortSingular = singular.length > 6 ? singular.slice(0, 6) + '.' : singular;
    const statusMap: { [key: string]: { message: string; color: string } } = {
      'SIGNED': { message: 'Assinado', color: '#FFFFFF' },
      'PENDING': { message: 'Não assinado', color: '#FFFFFF' },
      'NOT_SIGNED': { message: 'Não assinado', color: '#FFFFFF' },
      'PENDING_RESPONSIBLE': { message: 'Pendente Resp.', color: '#FFFFFF' },
      'SIGNED_ONLY_BY_RESPONSIBLE': { message: `Pendente ${shortSingular}`, color: '#FFFFFF' },
      'SIGNED_ONLY_BY_CLIENT': { message: 'Pendente Resp.', color: '#FFFFFF' }
    };

    return statusMap[status] || { message: status, color: '#FFFFFF' };
  }

  viewDocument(document: IContractDetail): void {
    if (document.autentique_info_list && document.autentique_info_list.length > 0) {
      window.open(`https://app.autentique.com.br/documentos/${document.autentique_info_list[0].document_id}`, '_blank');
    }
  }

  openContract(documentId: string): void {
    window.open(`https://app.autentique.com.br/documentos/${documentId}`, '_blank');
  }

  documentsPrevious(): void {
    if (this.documentsCurrentPage > 0) {
      this.documentsCurrentPage--;
      this.loadDocuments();
    }
  }

  documentsNext(): void {
    if (this.documentsCurrentPage < this.documentsTotalPages - 1) {
      this.documentsCurrentPage++;
      this.loadDocuments();
    }
  }

  documentsNavigateTo(page: number): void {
    this.documentsCurrentPage = page - 1;
    this.loadDocuments();
  }

  changeDocumentsPageSize(event: Event): void {
    this.documentsPageSize = parseInt((event.target as HTMLSelectElement).value);
    this.documentsCurrentPage = 0;
    this.loadDocuments();
  }

  // ========== TREATMENT PLANS ==========
  loadTreatmentPlans(): void {
    if (!this.patientId) return;

    this.loadingTreatmentPlans = true;
    
    this.treatmentPlanService.listAllTreatmentPlans(
      this.treatmentPlansCurrentPage,
      this.treatmentPlansPageSize,
      this.treatmentPlansStatusFilter,
      undefined,
      undefined,
      this.patientId,
      undefined
    ).subscribe({
      next: (response) => {
        this.treatmentPlans = response.data;
        this.treatmentPlansTotalPages = response.page_info.total_pages;
        this.loadingTreatmentPlans = false;
      },
      error: (error: Error) => {
        console.error('Erro ao carregar planos de tratamento:', error);
        this.treatmentPlans = [];
        this.loadingTreatmentPlans = false;
      }
    });
  }

  changeTreatmentPlansStatusFilter(status: 'ACTIVE' | 'CLOSED'): void {
    this.treatmentPlansStatusFilter = status;
    this.treatmentPlansCurrentPage = 0;
    this.loadTreatmentPlans();
  }

  viewTreatmentPlan(id: string): void {
    this.router.navigate(['main', 'v2', 'treatment-plan', id]);
  }

  treatmentPlansPrevious(): void {
    if (this.treatmentPlansCurrentPage > 0) {
      this.treatmentPlansCurrentPage--;
      this.loadTreatmentPlans();
    }
  }

  treatmentPlansNext(): void {
    if (this.treatmentPlansCurrentPage < this.treatmentPlansTotalPages - 1) {
      this.treatmentPlansCurrentPage++;
      this.loadTreatmentPlans();
    }
  }

  treatmentPlansNavigateTo(page: number): void {
    this.treatmentPlansCurrentPage = page - 1;
    this.loadTreatmentPlans();
  }

  changeTreatmentPlansPageSize(event: Event): void {
    this.treatmentPlansPageSize = parseInt((event.target as HTMLSelectElement).value);
    this.treatmentPlansCurrentPage = 0;
    this.loadTreatmentPlans();
  }

  formatTreatmentPlanDate(dateString: string | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  }

  formatTreatmentPlanCurrency(value: number | undefined): string {
    if (value === undefined || value === null) return 'R$ 0,00';
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  getTreatmentPlanStatusDisplay(status: string): string {
    return status === 'ACTIVE' ? 'Em aberto' : 'Encerrado';
  }

  getTreatmentPlanStatusClass(status: string): string {
    // Use a stronger background for ACTIVE so the badge text can be white and readable in v2
    return status === 'ACTIVE' ? 'bg-westetics-purple-800 text-white' : 'bg-gray-100 text-gray-800';
  }

  // ========== HEADER ACTIONS ==========
  onSendAnamnese(): void {
    // Para módulos que não são PACIENTES, navegar diretamente para criação de formulário
    // sem mostrar o modal de reutilização de anamnese
    if (this.modulesService.moduleName !== 'PACIENTES') {
      this.router.navigate(['main', 'v2', 'patients', 'anamnese', 'create'], {
        queryParams: {
          patientId: this.patientId,
          patientName: this.patientData?.full_name?.trim() || '',
          patientEmail: this.patientData?.email || '',
          patientPhoneNumber: this.patientData?.phone || '',
          reuseInfo: false
        }
      });
      return;
    }

    // Verifica se há anamnese anterior (apenas para módulo PACIENTES)
    this.anamneseModalLoading = true;
    this.showAnamneseModal = true;
    
    this.anamneseService.getAnamneseCreateStatus(this.patientId || '').subscribe({
      next: (status) => {
        this.hasPreviousAnamnese = status.has_previous_anamnese;
        this.hasUnansweredAnamnese = status.has_unanswered_anamnese;
        this.ongoingAnamneseId = status.ongoing_anamnese_id || '';
        this.anamneseModalLoading = false;
      },
      error: (error: any) => {
        console.error('Erro ao verificar status da anamnese:', error);
        this.anamneseModalLoading = false;
        // Se erro, assume que não tem anamnese anterior
        this.hasPreviousAnamnese = false;
        this.hasUnansweredAnamnese = false;
      }
    });
  }

  closeAnamneseModal(): void {
    if (!this.anamneseModalLoading) {
      this.showAnamneseModal = false;
    }
  }

  onConfirmAnamnese(reuseInfo: boolean): void {
    if (!this.anamneseModalLoading) {
      this.showAnamneseModal = false;
      this.router.navigate(['main', 'v2', 'patients', 'anamnese', 'create'], {
        queryParams: {
          patientId: this.patientId,
          patientName: this.patientData?.full_name?.trim() || '',
          patientEmail: this.patientData?.email || '',
          patientPhoneNumber: this.patientData?.phone || '',
          reuseInfo: reuseInfo
        }
      });
    }
  }

  onAccessOngoingAnamnese(): void {
    if (!this.anamneseModalLoading) {
      this.showAnamneseModal = false;
      this.router.navigate(['main', 'v2', 'patients', 'anamnese', this.ongoingAnamneseId, 'view'], {
        queryParams: {
          patientId: this.patientId,
          patientName: this.patientData?.full_name?.trim() || '',
          patientEmail: this.patientData?.email || '',
          patientPhoneNumber: this.patientData?.phone || ''
        }
      });
    }
  }

  onDeleteOngoingAnamnese(): void {
    if (!this.anamneseModalLoading) {
      this.anamneseModalLoading = true;
      this.anamneseService.deleteAnamnese(this.ongoingAnamneseId).subscribe({
        next: () => {
          this.anamneseModalLoading = false;
          if (this.hasPreviousAnamnese) {
            this.hasUnansweredAnamnese = false;
          } else {
            this.onConfirmAnamnese(false);
          }
        },
        error: (error: any) => {
          console.error('Erro ao excluir anamnese:', error);
          this.anamneseModalLoading = false;
        }
      });
    }
  }

  onGenerateDocumentsWithAnamnese(): void {
    if (!this.hasAnsweredAnamnese || !this.latestAnsweredAnamneseId) {
      // Mostra alerta se não há anamnese respondida
      this.store.dispatch(setWarningText('É necessário ter uma anamnese respondida para gerar documentos.'));
      return;
    }
    const isModelPatient = this.patientForm.get('isModelPatient')?.value || false;
    this.router.navigate(['main', 'v2', 'patients', 'generate-docs', this.latestAnsweredAnamneseId], {
      queryParams: { patientId: this.patientId, isModelPatient: isModelPatient }
    });
  }

  onGenerateStandaloneDocuments(): void {
    const patientName = this.patientForm.get('name')?.value?.trim() || '';
    const patientEmail = this.patientForm.get('email')?.value || '';
    const isModelPatient = this.patientForm.get('isModelPatient')?.value || false;
    const moduleName = this.modulesService.moduleName || '';
    
    this.router.navigate(['main', 'v2', 'patients', 'standalone-docs'], {
      queryParams: {
        patientId: this.patientId,
        patientName: patientName,
        patientEmail: patientEmail,
        standalone: this.hasToShowAnamnese && moduleName === 'PACIENTES',
        isModelPatient: isModelPatient
      }
    });
  }

  // ========== PHONE COUNTRY DROPDOWN ==========
  onClickPhoneCountryButton(): void {
    this.isDropdownPhoneOpen = !this.isDropdownPhoneOpen;
    if (this.isDropdownPhoneOpen) {
      this.filteredPhoneCountries = this.countriesDdi;
    }
  }

  filterPhoneCountries(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredPhoneCountries = this.countriesDdi.filter(country =>
      (country.pais?.toLowerCase() || '').includes(searchTerm) ||
      (country.ddi || '').includes(searchTerm)
    );
  }

  onClickSelectPhoneCountry(country: ICountriesDDI): void {
    this.patientForm.get('phoneCountryCode')?.setValue(country.pais);
    this.isDropdownPhoneOpen = false;
  }

  getSelectedPhoneCountry(): ICountriesDDI {
    const countryCode = this.patientForm.get('phoneCountryCode')?.value;
    return this.countriesDdi.find(c => c.pais === countryCode) || this.getDefaultCountryDdiObject();
  }

  getDefaultCountryDdiObject(): ICountriesDDI {
    return {
      pais: 'Brasil',
      img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/22px-Flag_of_Brazil.svg.png',
      ddi: '+55'
    } as ICountriesDDI;
  }

  // ========== GUARDIAN PHONE COUNTRY DROPDOWN ==========
  onClickGuardianPhoneCountryButton(): void {
    this.isDropdownGuardianPhoneOpen = !this.isDropdownGuardianPhoneOpen;
    if (this.isDropdownGuardianPhoneOpen) {
      this.filteredGuardianPhoneCountries = this.countriesDdi;
    }
  }

  filterGuardianPhoneCountries(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredGuardianPhoneCountries = this.countriesDdi.filter(country =>
      (country.pais?.toLowerCase() || '').includes(searchTerm) ||
      (country.ddi || '').includes(searchTerm)
    );
  }

  onClickSelectGuardianPhoneCountry(country: ICountriesDDI): void {
    this.patientForm.get('guardianPhoneCountryCode')?.setValue(country.pais);
    this.isDropdownGuardianPhoneOpen = false;
  }

  getSelectedGuardianPhoneCountry(): ICountriesDDI {
    const countryCode = this.patientForm.get('guardianPhoneCountryCode')?.value;
    return this.countriesDdi.find(c => c.pais === countryCode) || this.getDefaultCountryDdiObject();
  }

  // ========== COUNTRY DROPDOWN (ADDRESS) ==========
  onClickCountryButton(): void {
    this.isDropdownCountryOpen = !this.isDropdownCountryOpen;
    if (this.isDropdownCountryOpen) {
      this.filteredCountries = this.countriesDdi;
    }
  }

  filterCountries(event: Event): void {
    const input = event.target as HTMLInputElement;
    const query = input.value.toLowerCase().trim();
    if (!query) {
      this.filteredCountries = this.countriesDdi;
      return;
    }
    this.filteredCountries = this.countriesDdi.filter(country =>
      country.pais?.toLowerCase().includes(query)
    );
  }

  onClickSelectCountry(country: ICountriesDDI): void {
    this.patientForm.get('country')?.setValue(country.pais);
    this.isDropdownCountryOpen = false;
  }

  getSelectedCountry(): ICountriesDDI {
    const countryName = this.patientForm.get('country')?.value || 'Brasil';
    return this.countriesDdi.find(c => c.pais === countryName) || this.getDefaultCountryDdiObject();
  }

  // ========== CPF INPUT ==========
  onCpfCnpjInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length <= 11) {
      // CPF: 000.000.000-00
      if (value.length > 3) value = value.substring(0, 3) + '.' + value.substring(3);
      if (value.length > 7) value = value.substring(0, 7) + '.' + value.substring(7);
      if (value.length > 11) value = value.substring(0, 11) + '-' + value.substring(11, 13);
    } else {
      // CNPJ: 00.000.000/0000-00
      if (value.length > 2) value = value.substring(0, 2) + '.' + value.substring(2);
      if (value.length > 6) value = value.substring(0, 6) + '.' + value.substring(6);
      if (value.length > 10) value = value.substring(0, 10) + '/' + value.substring(10);
      if (value.length > 15) value = value.substring(0, 15) + '-' + value.substring(15, 17);
    }

    input.value = value;
    this.patientForm.get('cpf')?.setValue(value, { emitEvent: false });
  }

  // ========== CEP INPUT ==========
  onCepInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const isForeigner = this.patientForm.get('isForeigner')?.value;

    if (isForeigner) {
      // Para estrangeiros, aceita qualquer formato (letras, números, espaços, hífens)
      this.patientForm.get('zipCode')?.setValue(input.value, { emitEvent: false });
      return;
    }

    // Para brasileiros, aplica máscara de CEP (00000-000)
    let value = input.value.replace(/\D/g, '');

    if (value.length > 5) {
      value = value.substring(0, 5) + '-' + value.substring(5, 8);
    }

    input.value = value;
    this.patientForm.get('zipCode')?.setValue(value, { emitEvent: false });
  }

  cepOnChange(): void {
    const isForeigner = this.patientForm.get('isForeigner')?.value;
    if (isForeigner) return;

    const cep = this.patientForm.get('zipCode')?.value?.replace(/\D/g, '');
    if (!cep || cep.length !== 8) return;

    // Busca CEP via ViaCEP API
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then(response => response.json())
      .then(data => {
        if (!data.erro) {
          this.patientForm.patchValue({
            street: data.logradouro || '',
            neighborhood: data.bairro || '',
            city: data.localidade || '',
            state: data.uf || '',
            country: 'Brasil'
          });
        }
      })
      .catch(error => {
        console.error('Erro ao buscar CEP:', error);
      });
  }

  // ========== DATE INPUT ==========
  onBirthDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length >= 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length >= 5) {
      value = value.substring(0, 5) + '/' + value.substring(5, 9);
    }

    input.value = value;
    this.patientForm.get('birthDate')?.setValue(value, { emitEvent: false });

    // Atualiza a idade e verifica se é menor de idade
    this.updateMinorStatus(value);
  }

  /**
   * Atualiza o status de menor de idade baseado na data de nascimento
   */
  private updateMinorStatus(birthDateString: string): void {
    // Só calcula se a data estiver completa (DD/MM/YYYY = 10 caracteres)
    if (birthDateString && birthDateString.length === 10) {
      this.patientAge = this.calculateAge(birthDateString);
      this.isMinor = this.patientAge !== null && this.patientAge < 18;
    } else {
      // Se a data estiver incompleta, não considera menor de idade
      this.patientAge = null;
      this.isMinor = false;
    }
  }

  // ========== FORM ACTIONS ==========
  onCancel(): void {
    this.gotoModuleList();
  }

  onSubmit(): void {
    // Verifica se o nome (obrigatório) está preenchido
    if (this.patientForm.get('name')?.invalid) {
      this.patientForm.markAllAsTouched();
      this.store.dispatch(setWarningText('Preencha o campo Nome do Paciente.'));
      return;
    }

    // Verifica se o e-mail está com formato inválido (se foi preenchido)
    if (this.patientForm.get('email')?.invalid) {
      this.patientForm.markAllAsTouched();
      this.store.dispatch(setWarningText('Insira um e-mail válido (ex: nome@dominio.com).'));
      return;
    }

    // Verifica se o CPF está com formato inválido (se foi preenchido)
    if (this.patientForm.get('cpf')?.invalid) {
      this.patientForm.markAllAsTouched();
      this.store.dispatch(setWarningText(this.modulesService.moduleName === 'ALUNOS' ? 'Insira um CPF ou CNPJ válido.' : 'Insira um CPF válido.'));
      return;
    }

    // Verifica se o CPF do responsável está com formato inválido (se foi preenchido)
    if (this.patientForm.get('guardianCpf')?.invalid) {
      this.patientForm.markAllAsTouched();
      this.store.dispatch(setWarningText('Insira um CPF válido para o responsável.'));
      return;
    }

    this.loading = true;
    const formValue = this.patientForm.value;

    // Converte data de DD/MM/YYYY para YYYY-MM-DD.
    // Se o form carregou vazio (ex: data no banco em formato não parseável por
    // formatDateToDisplay) preserva o valor original em vez de sobrescrever
    // com string vazia.
    let birthDateFormatted = this.patientData?.birth_date || '';
    if (formValue.birthDate) {
      const parts = formValue.birthDate.split('/');
      if (parts.length === 3) {
        birthDateFormatted = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    const patientRequest: IPatient = {
      ...this.patientData, // Preserva dados existentes
      full_name: formValue.name?.trim() || '',
      email: formValue.email?.trim().toLowerCase() || '',
      phone: (formValue.phone || '').replace(/[^\d]+/g, ''),
      phone_country_code: formValue.phoneCountryCode || 'Brasil',
      birth_date: birthDateFormatted,
      profession: formValue.profession?.trim() || '',
      marital_status: formValue.maritalStatus || '',
      is_foreigner: formValue.isForeigner || false,
      is_model_patient: formValue.isModelPatient || false,
      instagram_account: formValue.instagramAccount?.trim() || '',
      rg: formValue.rg?.trim() || '',
      cpf: formValue.cpf?.trim() || '',
      address: {
        zip_code: formValue.zipCode?.trim() || '',
        street: formValue.street?.trim() || '',
        number: formValue.number?.trim() || '',
        complement: formValue.complement?.trim() || '',
        neighborhood: formValue.neighborhood?.trim() || '',
        city: formValue.city?.trim() || '',
        state: formValue.state?.trim() || '',
        country: formValue.country?.trim() || 'Brasil'
      },
      // Dados do responsável legal
      guardian_name: formValue.guardianName?.trim() || '',
      guardian_cpf: formValue.guardianCpf?.trim() || '',
      guardian_phone: (formValue.guardianPhone || '').replace(/[^\d]+/g, ''),
      guardian_phone_country_code: formValue.guardianPhoneCountryCode || 'Brasil',
      module: this.patientData?.module || { id: this.modulesService.moduleId } as any
    };

    

    this.patientsService.update(this.patientId || '', patientRequest).subscribe({
      next: (response) => {
       
        this.loading = false;
        // Atualiza os dados do paciente no header
        this.patientData = response;
        this.store.dispatch(setWarningText('Paciente atualizado com sucesso!'));
      },
      error: (error: any) => {
        console.error('Erro ao atualizar paciente:', error);
        this.store.dispatch(setWarningText('Erro ao atualizar paciente. Tente novamente.'));
        this.loading = false;
      }
    });
  }

  // ========== PAGINATION HELPER ==========
  generatePagination(currentPage: number, totalPages: number): number[] {
    const pages: number[] = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const startPage = Math.max(1, currentPage - 2);
      const endPage = Math.min(totalPages, startPage + maxVisible - 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

  // ========== RESEND DOCUMENTS FEATURE ==========
  showResendModal = false;
  resendModalLoading = false;
  resendDocumentsData: any = null;
  resendError: string | null = null;

  hasAnyPendingDocument(document: IContractDetail): boolean {
    if (!document.autentique_info_list) return false;
    return document.autentique_info_list.some(contract => 
      ['PENDING', 'SIGNED_ONLY_BY_RESPONSIBLE'].includes(contract.status)
    );
  }

  /**
   * Verifica se o documento (grupo de respostas) pode ser excluído.
   * Regras implementadas com base no solicitado:
   * - Deve permitir exclusão quando o documento estiver pendente / aguardando o paciente/responsável;
   * - Deve bloquear exclusão quando o paciente já assinou (SIGNED_ONLY_BY_CLIENT) ou quando ambos assinaram (SIGNED).
   */
  canDeleteDocument(document: IContractDetail): boolean {
    if (!document.autentique_info_list || document.autentique_info_list.length === 0) return false;
    // Se existir qualquer contrato onde o paciente já assinou (SIGNED_ONLY_BY_CLIENT) ou ambos assinaram (SIGNED), bloqueia exclusão
    const disallowedStatuses = ['SIGNED', 'SIGNED_ONLY_BY_CLIENT'];
    return !document.autentique_info_list.some(contract => disallowedStatuses.includes(contract.status));
  }

  async openResendModal(answerGroupId: string): Promise<void> {
    this.resendLoading = answerGroupId;
    this.showResendModal = true;
    this.resendModalLoading = true;
    this.resendDocumentsData = null;
    this.resendError = null;

    try {
      this.resendDocumentsData = await this.documentsService.getPendingDocumentUrls(answerGroupId);
    } catch (error: unknown) {
      const err = error as { message?: string };
      this.resendError = err?.message || 'Erro ao buscar links de assinatura. Tente novamente.';
    } finally {
      this.resendModalLoading = false;
      this.resendLoading = null;
    }
  }

  closeResendModal(): void {
    this.showResendModal = false;
    this.resendDocumentsData = null;
    this.resendError = null;
  }

  copyLink(url: string): void {
    this.copyToClipboard(url, 'Link copiado!');
  }

  copyWhatsAppMessage(): void {
    const message = this.buildWhatsAppMessage();
    this.copyToClipboard(message, 'Mensagem copiada!');
  }

  private copyToClipboard(text: string, successMessage: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.store.dispatch(setWarningText(successMessage, 200));
    }).catch(() => {
      this.store.dispatch(setWarningText('Erro ao copiar'));
    });
  }

  // Modal state for confirm delete
  public showConfirmDeletePopup = false;
  public pendingDeleteAnswerGroupId: string | null = null;
  public confirmDeleteLoading = false;

  /**
   * Opens the delete confirmation modal. Use this instead of native confirm().
   */
  deleteDocument(answerGroupId: string): void {
    if (!answerGroupId) return;
    this.showDeleteModal(answerGroupId);
  }

  showDeleteModal(answerGroupId?: string): void {
    if (answerGroupId) this.pendingDeleteAnswerGroupId = answerGroupId;
    this.showConfirmDeletePopup = true;
    try { this.cdr.detectChanges(); } catch (e) { /* noop */ }
    // focus the cancel button after it appears (helps tests/keyboard users)
    setTimeout(() => {
      const btn = document.getElementById('confirm-delete-cancel-btn') as HTMLButtonElement | null;
      if (btn) btn.focus();
    }, 0);
  }

  closeDeleteModal(): void {
    this.showConfirmDeletePopup = false;
    this.pendingDeleteAnswerGroupId = null;
  }

  confirmDelete(): void {
    const id = this.pendingDeleteAnswerGroupId;
    if (!id) return;
    this.confirmDeleteLoading = true;
    this.documentsService.deleteAnswerGroup(id)
      .then((response: any) => {
        // If backend returned a message, show it; otherwise keep a sensible fallback.
        const successMessage = response?.message || 'Documento excluído com sucesso.';
        // Dispatch with a 2xx status so the warning-modal treats it as success
        this.store.dispatch(setWarningText(successMessage, 200));
        this.closeDeleteModal();
        this.loadDocuments();
      })
      .catch((error: any) => {
        console.error('Erro ao excluir documento:', error);
        const errMsg = error?.message || 'Erro ao excluir documento. Tente novamente.';
        const errStatus = error?.status || 500;
        this.store.dispatch(setWarningText(errMsg, errStatus));
        this.closeDeleteModal();
      })
      .finally(() => {
        this.confirmDeleteLoading = false;
      });
  }

  buildWhatsAppMessage(): string {
    if (!this.resendDocumentsData) return '';

    let message = 'Olá! Seguem os links para assinatura dos documentos:\n\n';
    
    this.resendDocumentsData.documents.forEach((doc: any, index: number) => {
      message += `${index + 1}. ${doc.document_name}\n${doc.signature_url}\n\n`;
    });

    return message;
  }
}
